// import axios from "axios";

// export function qryUserIp() {
//     return axios.get("http://pv.sohu.com/cityjson", {headers: {"Access-Control-Allow-Origin": "*"}})
// }

export function qryUserIp() {
    return sessionStorage.getItem("ip");
}

export function qryUserIpAddress() {
    return sessionStorage.getItem("ipAddress");
}

export function qryUserAddress() {
    return sessionStorage.getItem("ipArea");
}
